import React, { useEffect, useState, Component } from 'react';
import { firebaseAuthentication } from '../../controller/firebase';

export const AuthContext = React.createContext();

export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);

    // 
    firebaseAuthentication.signInAnonymously()
        .then(() => {
            // Signed in..
        })
        .catch((error) => {
            var errorCode = error.code;
            var errorMessage = error.message;
            // ...
        });

    useEffect(() => {
        firebaseAuthentication.onAuthStateChanged(setCurrentUser)
    }, [])


    return (
        <AuthContext.Provider
            currentUser={{ currentUser }}
        >
            {children}
        </AuthContext.Provider>
    );
}

